import UIkit from "uikit";
import tippy from 'tippy.js';

var custom = (function ($, window, document, Drupal) {
  Drupal.behaviors.FisbaMenu = {
    attach: function (context) {
      const $menuBurger = $(".menu-burger", context);
      const $flyoutnavigation = $(".flyoutnavigation", context);
      const $lp_navigation = $(".lp-header__navigation", context);
      const $logo = $(".site-logo", context);

      function toggleHtmlStyles() {
        if ($("body").hasClass("sidenav-open")) {
          if (window.innerWidth > document.documentElement.clientWidth) {
            // calculate scrollbar width
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

            // Add padding-right to html tag
            $("html").css("padding-right", scrollbarWidth);
          }

          $("html").css("overflow", "hidden");
        } else {
          $("html").css("overflow", "");
          $("html").css("padding-right", "");
        }
      }

      $menuBurger.each(function () {
        $(this).click(function () {
          if ($(this).hasClass("lp-header__hamburger")) {
            $lp_navigation.toggleClass("menu-region-open");
          } else {
            $flyoutnavigation.toggleClass("menu-region-open");
          }

          $(this).toggleClass("menu-burger-open");
          $("body").toggleClass("sidenav-open");
          $logo.toggleClass("logo-hidden");

          // Toggle overflow hidden and padding-right on html tag
          toggleHtmlStyles();
        });

        $("body").on("click", function (event) {
          if (
            $("body").hasClass("sidenav-open") &&
            $(event.target).hasClass("flyoutnavigation") === true
          ) {
            $("body").toggleClass("sidenav-open");
            $flyoutnavigation.toggleClass("menu-region-open");
            $lp_navigation.toggleClass("menu-region-open");
            $menuBurger.toggleClass("menu-burger-open");
            $logo.toggleClass("logo-hidden");

            // Toggle overflow hidden and padding-right on html tag
            toggleHtmlStyles();
          }
        });
      });
    },
  };

  $.fn.isInViewport = function () {
    var elementTop = $(this).offset() ? $(this).offset().top : 0;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  Drupal.behaviors.MediaTextVideoBehavior = {
    attach: function (context) {
      const $video = $(".paragraph--type--media-text video");
      const $media = $(
        ".paragraph--type--media-text .media--bundle--video-local"
      );

      for (var i = 0; i < $video.length; i++) {
        if ($video[i].hasAttribute("controls")) {
          $video[i].removeAttribute("controls");
        }
      }
    }
  };

  Drupal.behaviors.VideoPlaysInline = {
    attach: function (context) {
      const $video = $("video");
      for (var i = 0; i < $video.length; i++) {
        $video[i].setAttribute("playsinline", true);
      }
    }
  };

  Drupal.behaviors.ReSizeHeader = {
    attach: function (context) {
      var screenheight;
      var screenwidth;
      const $headercollection = $(".paragraph--type--headers-collection");
      const $headerbig = $(".paragraph--type--header-big");
      const $headerimg = $(".paragraph--type--header-big").find("img");
      const $headervid = $(".paragraph--type--header-big").find("video");
      function reportWindowSize() {
        screenheight = window.innerHeight;
        screenwidth = window.innerWidth;
      }

      window.onresize = function () {
        reportWindowSize();
        if (screenwidth > 960) {
          $headerimg.css("height", "auto");
          $headercollection.css("height", "80vh");
          $headerbig.css("height", "80vh");
          $headervid.css("height", "auto");
        } else {
          var targetheight = screenwidth * 1.5;
          $headerimg.css("height", targetheight);
          $headervid.css("height", targetheight);
          targetheight = screenwidth * 1.5 + 400;
          $headercollection.css("height", targetheight);
          $headerbig.css("height", targetheight);
        }
      };
      window.onload = function () {
        reportWindowSize();
        if (screenwidth > 960) {
          $headerimg.css("height", "auto");
          $headercollection.css("height", "80vh");
          $headerbig.css("height", "80vh");
          $headervid.css("height", "auto");
        } else {
          var targetheight = screenwidth * 1.5;
          $headerimg.css("height", targetheight);
          $headervid.css("height", targetheight);
          targetheight = screenwidth * 1.5 + 400;
          $headercollection.css("height", targetheight);
          $headerbig.css("height", targetheight);
        }
      };
    }
  };

  Drupal.behaviors.HeaderBigsliderBar = {
    attach: function (context) {
      //Activate first indicator
      $("#headerslideshowwrapper > ul > li > a > .slide_selector")
        .first()
        .addClass("is-active");

      //Variables
      var $slidershow = UIkit.slideshow("#headerslideshow");
      var $slideritem = $("#headerslideshow ul > li");
      var $sliderqueue = [];
      var $indicatorqueue = [];

      //Generate Arrays of Slides and Indicators
      for (var i = 1; i <= $slideritem.length; i++) {
        $sliderqueue.push($(".slideshow-item-" + i));
        $indicatorqueue.push($(".slide_selector_" + i));
      }

      // Gets text color of active slide and adjusts the color of the indicator
      const generateIndicatorColor = (activeSlide) => {
        const headerBigTextColor = activeSlide.children(".header-big").css('--paragraph-text-color');
        const headerBigWrapper = activeSlide.parents('#headerslideshow');

        if (headerBigTextColor && headerBigWrapper) {
          headerBigWrapper.find('.slide_selector').css('background-color', headerBigTextColor);
        }
      }

      //Adjust color of first slide
      if ($sliderqueue[0]) {
        $sliderqueue[0].each(function () {
          generateIndicatorColor($(this));
        })
      }

      //Change activated indicator and color
      $slideritem.on("itemshown", function () {
        for (var i = 0; i < $slideritem.length; i++) {
          if ($sliderqueue[i].hasClass("uk-active")) {
            generateIndicatorColor($(this));
            $indicatorqueue[i].addClass("is-active");
          } else {
            $indicatorqueue[i].removeClass("is-active");
          }
        }
      });
    }
  };

  Drupal.behaviors.ContactBlock = {
    attach: function (context) {
      var $contactButton = $(".toggle-contact__btn", context);
      var $hiddenContent = $(".toggle-contact__article", context);
      var $closeButton = $(".article__close-btn", context);
      var $webformButton = $(".article__contact-btn", context);

      $contactButton.each(function () {
        $(this).click(function () {
          toggleContact();
        });
      });
      $closeButton.click(function (e) {
        e.preventDefault();
        toggleContact();
      });
      $webformButton.each(function () {
        $(this).click(function () {
          toggleContact();
        });
      });

      function toggleContact() {
        $hiddenContent.toggleClass("toggle-contact--open");
        $contactButton.toggle(750);

        // fix blazy infinite loading bug
        setTimeout(function () {
          window.dispatchEvent(new Event("resize"));
        }, 500);
      }
    }
  };

  Drupal.behaviors.getScrollbarWidth = {
    attach: function (context, settings) {
      let root = document.documentElement;

      // Creating invisible container
      const outer = document.createElement("div");
      outer.style.visibility = "hidden";
      outer.style.overflow = "scroll"; // forcing scrollbar to appear
      document.body.appendChild(outer);

      // Creating inner element and placing it in the container
      const inner = document.createElement("div");
      outer.appendChild(inner);

      // Calculating difference between container's full width and the child width
      const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

      // Removing temporary elements from the DOM
      outer.parentNode.removeChild(outer);

      root.style.setProperty("--scrollbarWidth", `${scrollbarWidth}px`);
    }
  };

  // Scroll Class
  //
  Drupal.behaviors.AddClassonScroll = {
    attach: function (context, settings) {
      $(document).ready(function () {
        $(window).on("scroll", function () {
          if ($(this).scrollTop() > 5) {
            $("body").addClass("scroll-active");
          } else {
            $("body").removeClass("scroll-active");
          }
        });
      });
    }
  };

  // Mobile: Menu Levels.
  //
  Drupal.behaviors.mobileMenuLevels = {
    attach: function (context, settings) {
      // Only apply this logic on mobile devices
      const isMobile = () => {
        return window.innerWidth < 960; // Common breakpoint for mobile devices
      };

      let mobileMenu = $("#block-fisba-main-menu");
      let mobileMenuHeader = $(".flyoutnavigation__header");
      let mobileMenuTitle = $("h2.flyoutnavigation--title");
      let mainUl = $("#block-fisba-main-menu > ul.menu");
      let arrowBack = $(".flyoutnavigation--back");
      let level = 0;
      // Store last active level in a variable
      let lastActiveLevel = 0;

      // Exit early if not mobile and we're not forcing mobile menu
      if (!isMobile() && !$("body").hasClass("force-mobile-menu")) {
        return;
      }

      // Initial setup for dropdown navigation
      setupDropdownNavigation();

      function setupDropdownNavigation() {
        // Reset any previous setups
        $("#block-fisba-main-menu button").off('click');
        $("#block-fisba-main-menu .arrow-next-level").off('click');

        // Reset styles
        $("#block-fisba-main-menu li").show();
        $("#block-fisba-main-menu ul").removeClass('open');
        $("#block-fisba-main-menu .arrow-next-level").css('transform', 'rotate(0deg)');

        // Hide all submenus initially
        $("#block-fisba-main-menu ul.menu ul").hide();

        // Find all buttons that contain both a link and the arrow for next level
        $("#block-fisba-main-menu button").each(function () {
          const $button = $(this);
          const $link = $button.find('> a');
          const $arrow = $button.find('> .arrow-next-level');
          const $parentLi = $button.closest('li');
          const $submenu = $parentLi.find('> ul');

          // Only process buttons that have both a link and an arrow
          if ($link.length && $arrow.length) {
            // Remove any existing event handlers
            $button.off('click');

            // Stop the button from being clickable directly
            $button.css('pointer-events', 'none');

            // Make the arrow clickable for dropdown toggle
            $arrow.css({
              'width': '40px', // Adjust as needed
              'pointer-events': 'auto',
              'z-index': '2',
              'cursor': 'pointer',
              'display': 'inline-block',
              'position': 'absolute',
              'right': '10px',
              'top': '25px'
            });

            // Add click handler only to the arrow
            $arrow.on('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              if (!isMobile() && !$("body").hasClass("force-mobile-menu")) {
                return; // Skip on desktop
              }

              // Toggle the submenu display
              if ($submenu.is(':visible')) {
                $submenu.slideUp(200);
                $parentLi.removeClass('expanded');
                $arrow.removeClass('open');
                $arrow.css('transform', 'rotate(0deg)');
              } else {
                // First close any sibling submenus
                $parentLi.siblings().find('> ul').slideUp(200);
                $parentLi.siblings().removeClass('expanded');
                $parentLi.siblings().find('> button > .arrow-next-level').removeClass('open').css('transform', 'rotate(0deg)');

                // Then open this submenu
                $submenu.slideDown(200);
                $parentLi.addClass('expanded');
                $arrow.addClass('open');
                $arrow.css('transform', 'rotate(90deg)');
              }
            });

            // Make the link area clickable for navigation
            $link.css({
              'position': 'relative',
              'z-index': '1',
              'pointer-events': 'auto',
              'display': 'inline-block',
              'width': 'calc(100% - 40px)' // Adjust based on arrow width
            });
          } else if ($submenu.length) {
            // For menu items without links but with submenus
            $button.on('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              if (!isMobile() && !$("body").hasClass("force-mobile-menu")) {
                return; // Skip on desktop
              }

              // Toggle the submenu display
              if ($submenu.is(':visible')) {
                $submenu.slideUp(200);
                $parentLi.removeClass('expanded');
                $(this).removeClass('open');
                $(this).find('> .arrow-next-level').css('transform', 'rotate(0deg)');
              } else {
                // Close sibling submenus
                $parentLi.siblings().find('> ul').slideUp(200);
                $parentLi.siblings().removeClass('expanded');
                $parentLi.siblings().find('> button').removeClass('open');
                $parentLi.siblings().find('> button > .arrow-next-level').css('transform', 'rotate(0deg)');

                // Open this submenu
                $submenu.slideDown(200);
                $parentLi.addClass('expanded');
                $(this).addClass('open');
                $(this).find('> .arrow-next-level').css('transform', 'rotate(90deg)');
              }
            });

            // Style the arrow for consistency with link+arrow items
            const $arrow = $button.find('> .arrow-next-level');
            if ($arrow.length) {
              $arrow.css({
                'width': '40px', // Same width as arrows with links
                'pointer-events': 'auto',
                'z-index': '2',
                'cursor': 'pointer',
                'display': 'inline-block',
                'position': 'absolute',
                'right': '10px',
                'top': '25px'
              });
            }
          }
        });

        // Add CSS for dropdown styling
        applyDropdownStyles();
      }

      // Apply dropdown-specific CSS
      function applyDropdownStyles() {
        // Add animation and styling to the dropdown
        const styleId = 'fisba-dropdown-styles';
        if (!$('#' + styleId).length) {
          const dropdownStyles = `
            <style id="${styleId}">
              @media (max-width: 959px) {
                #block-fisba-main-menu ul.menu {
                  display: block;
                  width: 100%;
                }
                #block-fisba-main-menu li {
                  display: block;
                  width: 100%;
                  position: relative;
                }
                #block-fisba-main-menu button {
                  display: block;
                  width: 100%;
                  text-align: left;
                }
                #block-fisba-main-menu ul.menu ul {
                  width: 100%;
                  padding-left: 20px;
                }
                #block-fisba-main-menu .arrow-next-level {
                  transition: transform 0.3s ease;
                  display: inline-block !important;
                  min-width: 20px;
                  min-height: 20px;
                  transform: rotate(0deg);
                }
                #block-fisba-main-menu .arrow-next-level.open {
                  transform: rotate(90deg);
                }
                .flyoutnavigation__header,
                .flyoutnavigation--back {
                  display: none !important;
                }
              }
              
              /* Hide arrows in desktop view */
              @media (min-width: 960px) {
                #block-fisba-main-menu .arrow-next-level {
                  display: none !important;
                }
              }
            </style>
          `;
          $('head').append(dropdownStyles);
        }
      }

      // Watch for window resize to toggle mobile menu behavior
      $(window).on('resize', function () {
        if (isMobile() || $("body").hasClass("force-mobile-menu")) {
          setupDropdownNavigation();
          // Show arrows in mobile view
          $("#block-fisba-main-menu .arrow-next-level").css('display', 'inline-block');
        } else {
          // Reset for desktop view
          $("#block-fisba-main-menu li").show();
          $("#block-fisba-main-menu ul").show();
          $("#block-fisba-main-menu button").off('click');
          $("#block-fisba-main-menu .arrow-next-level").off('click');
          // Hide arrows in desktop view
          $("#block-fisba-main-menu .arrow-next-level").css('display', 'none');
        }
      });

      // Expand active trail items
      function expandActiveTrail() {
        const $activeTrail = $('#block-fisba-main-menu .menu-item--active-trail');
        $activeTrail.each(function () {
          const $submenu = $(this).find('> ul');
          if ($submenu.length) {
            $submenu.show();
            $(this).addClass('expanded');
            const $arrow = $(this).find('> button > .arrow-next-level');
            $arrow.addClass('open');
            $arrow.css('transform', 'rotate(90deg)');
          }
        });
      }

      // Open active trail when menu is opened
      $(".menu-burger").on("click", function () {
        if (!isMobile() && !$("body").hasClass("force-mobile-menu")) {
          return; // Skip on desktop
        }

        if ($(this).hasClass("menu-burger-open")) {
          setTimeout(function () {
            expandActiveTrail();
          }, 100);
        }
      });

      // Also apply the correct arrow rotation to the initially expanded items
      $('#block-fisba-main-menu .expanded > button > .arrow-next-level, #block-fisba-main-menu .menu-item--active-trail > button > .arrow-next-level').each(function () {
        $(this).css('transform', 'rotate(90deg)');
      });

      // Apply initial setup
      expandActiveTrail();
    }
  };

  Drupal.behaviors.modalClose = {
    attach: function (context) {
      $(document).ready(function () {
        $(".ui-widget-overlay").click(function () {
          $(".ui-dialog-titlebar-close").trigger("click");
        });
      });
    }
  };

  Drupal.behaviors.CloseUI = {
    attach: function (context) {
      $(document).ready(function () {
        $(document)
          .unbind()
          .click(function (event) {
            if ($(".toggle-contact").length || $(".view-filters").length) {
              if (
                event.target == $(".toggle-contact")[0] ||
                event.target == $(".view-filters")[0]
              ) {
                return;
              }
              if (
                ($(".toggle-contact")[0] != null &&
                  $(".toggle-contact")[0].contains(event.target)) ||
                ($(".view-filters")[0] != null &&
                  $(".view-filters")[0].contains(event.target))
              ) {
                return;
              }
              if (
                $(".toggle-contact")
                  .find("#hidden-article")
                  .hasClass("toggle-contact--open")
              ) {
                $(".toggle-contact")
                  .find("#close")
                  .trigger("click");
              }
              if (
                $(".view-filters")
                  .find("summary")
                  .attr("aria-expanded") == "true"
              ) {
                $(".view-filters")
                  .find("summary")
                  .trigger("click");
              }
            }
          });
      });
    }
  };

  // Arrow down
  Drupal.behaviors.arrowDown = {
    attach: function (context, settings) {
      $(".arrowLink", "#headerslideshow").click(function (e) {
        $("html, body").animate(
          {
            scrollTop:
              $("#headerslideshow")
                .parents()
                .next()
                .offset().top - 100
          },
          0
        );
      });

      $(".arrowLink", ".paragraph--type--header-small").click(function (e) {
        $("html, body").animate(
          {
            scrollTop:
              $(".paragraph--type--header-small")
                .parents()
                .next()
                .offset().top - 100
          },
          0
        );
      });
    }
  };

  // Change Webform Select on toggle

  Drupal.behaviors.selectToggle = {
    attach: function (context, settings) {
      $(".form-select").on("change", function () {
        $(this).css("color", "black");
        $(this)
          .children("option[selected='selected']")
          .first()
          .remove();
      });
    }
  };

  //Webform Order Button

  Drupal.behaviors.OrderAttribute = {
    attach: function (context, settings) {
      if (settings.custom != null) {
        var translatedString = settings.custom.translations.order_input;
        $("#order_table .webform-multiple-add input.button").val(
          translatedString
        );
      }
    }
  };

  //Webform Order Table

  Drupal.behaviors.OrderTable = {
    attach: function (context, settings) {
      $(
        "#order_table table tr td:not(.webform-multiple-table--operations)"
      ).addClass(
        "uk-grid uk-child-width-1-2@m uk-child-width-1-1@s order cell-active"
      );
    }
  };

  Drupal.behaviors.OrderRemoveItemButton = {
    attach: function (context, settings) {
      $("#order_table table .webform-multiple-table--operations input").attr(
        "src",
        "/themes/custom/fisba/src/assets/images/icons/minus.svg"
      );
    }
  };

  // Timeline navigation.
  Drupal.behaviors.timelineNavigation = {
    attach: function (context, settings) {
      let stickyTop = 0,
        scrollTarget = false;

      let timeline = $(".timeline"),
        items = $(".pg-history-timeline", timeline),
        offsetTop = parseInt(timeline.css("top"));

      const TIMELINE_VALUES = {
        start: 190,
        step: 30
      };

      $(window)
        .resize(function () {
          if (timeline.length) {
            stickyTop = timeline.offset().top - offsetTop;
          }
          $(window).trigger("scroll");
        })
        .trigger("resize");

      $(".year-link").click(function () {
        $(".year-link")
          .closest(".pg-history-timeline")
          .removeClass("active");
        $(this)
          .closest(".pg-history-timeline")
          .addClass("active");
      });

      $(window)
        .scroll(function () {
          let viewLine = $(window).scrollTop() + $(window).height() / 3,
            active = -1;

          if (scrollTarget === false) {
            $(".pg-history-timeline--content").each(function () {
              let offsetTop = $(this).offset().top;
              let difference = offsetTop - viewLine;
              if (difference > 0) {
                return false;
              }
              active++;
            });
          } else {
            active = scrollTarget;
          }

          items.filter(".active").removeClass("active");
          items.eq(active != -1 ? active : 0).addClass("active");
        })
        .trigger("scroll");
    }
  };

  Drupal.behaviors.sliderRevalidate = {
    attach: function (context, settings) {
      $("a[uk-slider-item]").on("click", function () {
        setTimeout(function () {
          window.dispatchEvent(new Event("resize"));
        }, 500);
      });
    }
  };

  // video play fix for safari browser navigation
  Drupal.behaviors.videoPlay = {
    attach: function (context, settings) {
      // check if page is loaded from cache
      window.onpageshow = function (event) {
        if (event.persisted) {
          var videoList = document.getElementsByTagName("video");
          videoList.forEach(video => {
            video.play();
          });
        }
      };
    }
  };

  /*
   * Landing page active menu item
   */
  Drupal.behaviors.landingPageActiveMenu = {
    attach: function () {
      const menuItems = document.querySelectorAll(".lp-header nav a");
      const body = document.querySelector("body");

      if (body.classList.contains("page-node-type-landing-page")) {
        document.addEventListener("scroll", e => {
          e.preventDefault();
          let windowTop = window.scrollY;

          menuItems.forEach(item => {
            let linkToParagraph = item.getAttribute("href").split("#")[1];
            let anchorToParagraph = '#' + linkToParagraph.substring(linkToParagraph.indexOf("#") + 1);
            let paragraph = document.querySelector(anchorToParagraph);

            if (
              windowTop >= (paragraph.offsetTop - 100) &&
              windowTop <= (paragraph.offsetHeight + paragraph.offsetTop)
            ) {
              let activeLink = document.querySelector(".lp-header nav .active");
              activeLink ? activeLink.classList.remove("active") : "";
              item.classList.add("active");
            } else {
              item.classList.remove("active");
            }
          });

          let hamburger = document.querySelector(".menu-burger");

          if (hamburger.classList.contains("menu-burger-open")) {
            hamburger.click();
          }
        });
      }
    }
  };

  Drupal.behaviors.tabsParagraphUtility = {
    attach: function () {
      let allTabParagraphs = document.querySelectorAll(".paragraph-tabs");

      // Helper to get the index of the element.
      const getIndexOfElement = item => {
        let allChildren = item.parentElement.children;
        let itemPosition = 0;
        for (let i = 0; i < allChildren.length; i++) {
          if (allChildren[i] == item) {
            return itemPosition;
          }
          if (allChildren[i].nodeType == 1) {
            itemPosition++;
          }
        }
        return -1;
      };

      allTabParagraphs.forEach(tabParagraph => {
        let tabNavigation = tabParagraph.querySelectorAll(
          ".paragraph-tabs__nav button"
        );

        let accordionNavigation = tabParagraph.querySelectorAll(
          ".paragraph-tabs__accordion button"
        );

        // Check if accordion (Mobile).
        if (
          accordionNavigation.length !== 0 &&
          window.getComputedStyle(accordionNavigation.item(0)).display !==
          "none"
        ) {
          // Close all accordion on mobile
          tabParagraph
            .querySelector(".paragraph-tabs__accordion.active")
            .classList.remove("active");

          accordionNavigation.forEach(item => {
            item.addEventListener("click", () => {
              let parentElement = item.parentElement;
              parentElement.classList.toggle("active");

              if (item.getAttribute("aria-expanded") == "true") {
                item.setAttribute("aria-expanded", "false");
              } else {
                item.setAttribute("aria-expanded", "true");
              }
            });
          });
        }

        // Check if tab nav (Desktop).
        if (
          tabNavigation.length !== 0 &&
          window.getComputedStyle(tabNavigation.item(0)).display !== "none"
        ) {
          tabNavigation.forEach(item => {
            item.addEventListener("click", () => {
              let index = getIndexOfElement(item);

              // Disable old tab button
              let getActiveButton = tabParagraph.querySelector(
                ".paragraph-tabs__nav .active"
              );
              getActiveButton.classList.remove("active");
              getActiveButton.setAttribute("aria-expanded", "false");

              // Hide old content
              let getActiveContent = tabParagraph.querySelector(
                ".paragraph-tabs__container .active"
              );

              getActiveContent
                ? getActiveContent.classList.remove("active")
                : null;

              // Show new content
              let setActiveContent = tabParagraph.querySelector(
                `.paragraph-tabs__container > div:nth-child(${++index})`
              );

              setActiveContent
                ? setActiveContent.classList.add("active")
                : null;
              item.classList.add("active");
              item.setAttribute("aria-expanded", "true");
            });
          });
        }
      });
    }
  };

  Drupal.behaviors.accordionParagraphUtility = {
    attach: function () {
      const accordionButtons = document.querySelectorAll(
        ".paragraph-accordion-item__button"
      );

      accordionButtons.forEach(button => {
        button.addEventListener("click", () => {
          let accordion = button.parentElement;
          accordion.classList.toggle("active");

          if (button.getAttribute("aria-expanded") == "true") {
            button.setAttribute("aria-expanded", "false");
          } else {
            button.setAttribute("aria-expanded", "true");
          }
        });
      });
    }
  };

  Drupal.behaviors.tooltipProduct = {
    attach: function () {
      const productEl = document.querySelectorAll(".product-variation");

      productEl.forEach((item) => {
        const button = item.querySelector(".product-variation__information");
        const template = item.querySelector('.product-variation__tooltip .text-formatted');

        tippy(button, {
          content: template.innerHTML,
          placement: 'top',
          animation: 'fade',
          arrow: true,
          interactive: true,
          allowHTML: true,
          maxWidth: '250px'
        });
      });

    },
  };

  Drupal.behaviors.commerceCartButton = {
    attach: function (context) {
      var $context = $(context);
      var $cartButton = $context.find('.cart-block--link__expand');

      // Hide the simple status messages when the link is clicked.
      $cartButton.on('click', function (e) {
        $('.simple-status-messages').fadeOut('slow');
      });
    }
  };

  Drupal.behaviors.lazyVideo = {
    attach: function () {
      const lazyVideos = Array.from(document.querySelectorAll("video"));
      if ("IntersectionObserver" in window) {
        const lazyVideoObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((video) => {
              if (video.isIntersecting) {
                // Get source of the video
                let source = video.target.querySelector("source");

                if (typeof source.tagName === "string" && source.tagName === "SOURCE") {
                  source.src = source.dataset.src;
                }

                video.target.load();
                lazyVideoObserver.unobserve(video.target);
              }
            });
          }
        );

        lazyVideos.forEach((lazyVideo) => {
          lazyVideoObserver.observe(lazyVideo);
        });
      }
    },
  };





})(jQuery, window, document, Drupal);

export default custom;
